<template>
  <div>
    <button class="btn btn-sm m-l-lg m-b-sm" type="button" @click="chartOpen()" >
      {{ isOpen ? 'Close' : 'Open' }}
    </button>
    <span class="m-l-lg lead"> {{ chartName }} </span>

    <transition name="expand">
      <div v-if="isOpen" class="list">
        <apexchart type=bar :height="this.height" :options="this.chartOptions" :series="this.series"/>
        <apexchart v-if="showBrush" type=bar :height="this.height/2" :options="this.brushOptions" :series="this.seriesBrush" />
      </div>
    </transition>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import Vue from 'vue'
import { startCase, toLower } from 'lodash'

Vue.component('apexchart', VueApexCharts)
export default {
  props: {
    type: {
      type: String,
      required: false
    },
    showBrush: {
      type: Boolean,
      required: false,
      default: false
    },
    name: {
      type: String,
      required: true
    },
    height: {
      type: Number,
      default: 240
    },
    uniqueName: {
      type: String,
      required: true
    },
    filterParams: {
      type: Object
    },
    isChartOpen: {
      type: Boolean,
      default: false
    }
  },

  data () {
    let thisData = {
      autoScaleYaxis: false,
      isOpen: false,
      chartData: []
    }
    if (this.isChartOpen) {
      this.$http.get(`business_intelligence/${this.uniqueName}/data`, { params: this.filterParams }).then(response => {
        this.isOpen = true
        thisData.chartData = response.data[0].data
      })
    }
    return thisData
  },
  methods: {
    chartOpen () {
      this.isOpen = !this.isOpen
      this.$http.get(`business_intelligence/${this.uniqueName}/data`, { params: this.filterParams }).then(response => {
        this.chartData = response.data[0].data
      })
    }
  },
  computed: {
    chartName () {
      return startCase(toLower(this.name))
    },
    xaxisCategories () {
      return Object.keys(this.chartData).map((value) => {
        return value
      })
    },

    series () {
      return [{
        name: startCase(toLower(this.name)),
        data: Object.keys(this.chartData).map((e) => {
          return this.chartData[e]
        })
      }]
    },

    seriesBrush () {
      return [
        { data: Object.keys(this.chartData).map((e) => {
          return this.chartData[e]
        }),
        name: this.name + 'Brush' }
      ]
    },

    chartOptions () {
      return {
        title: {
          text: '',
          align: 'left',
          offsetY: 20
        },
        dataLabels: {
          style: {
            colors: ['#000000']
          }
        },
        chart: {
          zoom: {
            enabled: true
          },
          id: this.name,
          toolbar: {
            autoSelected: 'pan',

            show: true
          },
          name: this.name,
          type: 'bar'
        },
        xaxis: {
          tickPlacement: 'on',
          categories: this.xaxisCategories
        },
        tooltip: {
          x: {
            formatter: (val) => {
              if (Array.isArray(val)) {
                return val.join(' ')
              }
              return val
            }
          }
        },
        reversed: true
      }
    },

    brushOptions () {
      return {
        legend: {
          show: false
        },
        chart: {
          id: this.name + 'Brush',
          brush: {
            target: this.name,
            enabled: true,
            autoScaleYaxis: this.autoScaleYaxis
          },
          selection: {
            enabled: true,
            xaxis: {
              min: 0,
              max: this.chartData.length < 23 ? this.chartData.length : 23
            }
          },
          type: 'bar'
        },
        colors: ['#008FFB'],
        fill: {
          type: 'gradient',
          gradient: {
            type: 'vertical',
            opacityFrom: 0.91,
            opacityTo: 0.8
          }
        },
        xaxis: {
          tooltip: {
            enabled: false
          }
        }
      }
    }
  }
}
</script>
